import { AdapterRegistry, IModel, SalesforceServiceCloudV2Dataset } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { SalesforceV2DatasetAdapter, salesforceV2DatasetAdapts } from './salesforce-v2-dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceServiceCloudV2Dataset),
    asynchronous: true,
    adapts: salesforceV2DatasetAdapts
})
export class SalesforceServiceCloudV2DatasetAdapter extends SalesforceV2DatasetAdapter {
    protected model(): IModel {
        return SalesforceServiceCloudV2Dataset.MODEL;
    }
}
